__turbopack_context__.v({
  "container": "LRlQDW_container",
  "more": "LRlQDW_more",
  "result": "LRlQDW_result",
});
